import { CampaignStateDefinition } from 'modules/graphql/types';
import {
  AbortedBadge,
  DraftBadge,
  FinishedBadge,
  ReadyBadge,
  RecalledBadge,
  RecurringBadge,
  RunningBadge,
  ScheduledBadge,
} from 'ui/badge';

/**
 * Some of the following campaign states don't map to badges as they
 * don't currently exist.
 */
export const campaignStateBadge = (status: CampaignStateDefinition) =>
  ({
    Aborted: <AbortedBadge />,
    Archived: '',
    Draft: <DraftBadge />,
    Finished: <FinishedBadge />,
    Ready: <ReadyBadge />,
    Recalled: <RecalledBadge />,
    Recalling: '',
    Recurring: <RecurringBadge />,
    Running: <RunningBadge />,
    Scheduled: <ScheduledBadge />,
  })[status];
